<script>
import dialog2Mixin from "../mixins/dialog2";

export default {
  components: {
    ContentNewsletterTip: () => import("@components/Content/ContentNewsletterTip"),
  },
  mixins: [dialog2Mixin],
}
</script>
<!-- section template -->
<template>
  <el-dialog
    :visible.sync="dialog2MixinVisible"
    :custom-class="`${ $style.dialogNewsletterTip } isStyleBase text-center`"
    width="1300px"
    append-to-body
    @closed="$Dialog2MixinOnDestroy"
  >
    <h1 class="dialogNewsletterTip__title">收不到簡訊驗證碼？(一次性密碼OTP)怎麼辦</h1>
    <ContentNewsletterTip/>
  </el-dialog>
</template>
<!-- section style -->
<style lang="scss" module>
.dialogNewsletterTip {
  :global {
    .dialogNewsletterTip {
      &__title {
        margin-bottom: 3rem;
        font-size: 2rem;

        @include max-md {
          font-size: 1.5rem;
        }
      }
    }
  }
}
</style>
